var alignment_rtlignore_default = {
  "alignLeft": "I1dJ6",
  "textWrapNowrap": "ViOV1",
  "alignRight": "D2r8Y",
  "alignCenter": "-ggrV",
  "sizeFullWidth": "fvNVX",
  "renderedInTable": "ALQ4R",
  "sizeOriginal": "yizqQ",
  "sizeContent": "DeWW3",
  "sizeSmall": "jd6Ax",
  "sizeSmallCenter": "r-d8-",
  "flex": "B-Bvt",
  "LEFT": "OkkXk",
  "CENTER": "cLjui",
  "RIGHT": "_8B3X1",
  "AUTO": "vxRmF",
  "JUSTIFY": "hxaKE"
};
export {
  alignment_rtlignore_default as default
};
//# sourceMappingURL=alignment.rtlignore-scss.js.map
